<template>
	<div
		v-if="showAttributionModule"
		class="sponsor-attribution"
		v-show="attributionVisible"
		v-metric="{ module: moduleName }"
	>
		<span class="sponsor-attribution-tooltip">
			<span class="sponsor-attribution-tooltiptext">
				{{ attributionInfoHoverText }}
			</span>
		</span>
		<span class="sponsor-attribution-text">
			{{ supportedByTitle }}
		</span>
		<span
			class="sponsor-attribution-logo"
			v-if="attributionLinkHref != ''"
		>
			<a
				:data-metrics-link="moduleLinkName"
				v-metric="{ link: moduleLinkName }"
				:href="attributionLinkHref"
			>
				<img
					:alt="attributionLogoAlt"
					:src="attributionLogo"
				/>
			</a>
		</span>
		<span
			class="sponsor-attribution-logo"
			v-else
		>
			<img
				:alt="attributionLogoAlt"
				:src="attributionLogo"
			/>
		</span>
	</div>
</template>

<script>
import useStore from 'webmd-cms-store/src/store';


import _includes from 'lodash/includes';
import _has from 'lodash/has';
import _get from 'lodash/get';
import _find from 'lodash/find';

export default {
	name: 'WebmdGlobalAttribution',
	props: {
		chronicId: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			moduleData: {},
			supportedByTitle: '',
			moduleLinkName: 'logo',
			moduleName: 'attribution',
			showAttributionModule: true,
			attributionInfoHoverText: 'Content controlled by WebMD',
			isBlogPostPage: false,
			allModuleData: {},
			isSponsor: false,
			attributionLogo: '',
			attributionLogoAlt: '',
			attributionLinkHref: '',
			isBlogPage: false,
			attributionVisible: true,
		};
	},
	computed: {
		getImageServerUrl() {
			return this.store.pagedata
				? this.store.pagedata.omniture.image_server_url
				: 'https://img.webmd.com/dtmcms/live';
		},

		getModuleData() {
			return this.store.cms.getModules(this.chronicId);
		},

		getAllModulesInfo() {
			return this.store.cms.allModules;
		},
	},
	created() {
       this.store = useStore(this.$pinia);
		this.moduleData = this.getModuleData || {};
		this.allModuleData = this.getAllModulesInfo;
		this.attributionLogo = this.getAbsoluteUrl(_get(this.moduleData, 'module_data.icon_image.path', ''));
		this.attributionLogoAlt = _get(this.moduleData, 'module_data.icon_image.alt', '');
		this.attributionLinkHref = _get(this.moduleData, 'module_data.module_link.link_friendlyUrl', '');
		if(_get(this.moduleData, 'module_data.icon_image.path', '')) {
   			this.preloadImage(this.attributionLogo);
		}
		this.verifyIsBlogPostPage(this.allModuleData);
		this.isBlogPage = this.isBlog();
		this.attributionVisible = !this.isBlogPage;
		if (this.isBlogPage && this.isBlogPostPage) {
			if (this.isSponsor) {
				this.supportedByTitle = 'Sponsor content from:';
			} else {
				this.showAttributionModule = false;
			}
		} else {
			this.supportedByTitle =	_get(this.moduleData, 'module_data.title', '') || 'Sponsor Content:';
		}
		if (
			!this.moduleData
			|| !(_get(this.moduleData, 'module_data.icon_image.path'))
		) {
			this.showAttributionModule = false;
		}
	},
	mounted() {
		if(this.showAttributionModule && this.isBlogPage) {
			setTimeout(() => this.attributionVisible = true, 2000);
		}
	},
	methods: {
		isBlog() {
			let checkBlog = false;
			if (_has(this.store.pagedata, 'omniture.center_prefix')
				&& this.store.pagedata.omniture.center_prefix.toLowerCase() === 'blogs') {
				checkBlog = true;
			}
			return checkBlog;
		},
		getAbsoluteUrl(imgUrl) {
			return `${this.getImageServerUrl}${imgUrl}?resize=*:*`;
		},
		verifyIsBlogPostPage(moduleObj) {
			const blogPostObj = _find(Object.values(moduleObj), (item) => item.module_settings && item.module_settings.Class === 'DynamicArticle');
			if (blogPostObj) {
				this.isBlogPostPage = true;
				const primTopicId = _get(blogPostObj, 'module_settings.metadata_section.wbmd_c_prim_top_id', '');
				if (_includes(primTopicId.wbmd_disp_nm, 'Sponsor Content')) {
					this.isSponsor = true;
				}
			}
		},
		preloadImage(imageUrl) {
			this.store.cms.appendPreLoadData({ url: imageUrl, type: 'image' });
		},
	},
};
</script>

<style lang="scss">
@import "styles/_variables.scss";
.sponsor-attribution {
	align-items: center;
	display: flex;
	margin-left: auto;
	padding-right: 1.25rem;
	@media (max-width: $mobile) {
		padding-right: 0;
	}
	.sponsor-attribution-tooltip {
		display: inline-block;
		position: relative;
		@media (max-width: $mobile) {
			margin-top: 0.3125rem;
		}
		&:after {
			background: url($attribution-icon-url)	no-repeat;
			background-size: 1.1875rem;
			color: $tooltip-icon-color;
			content: "";
			padding-right: 1.875rem;
			@media (max-width: $mobile) {
				background-size: 0.9375rem;
				padding-right: 1.3125rem;
			}
		}
		&:hover {
			.sponsor-attribution-tooltiptext {
				visibility: visible;
			}
		}
		.sponsor-attribution-tooltiptext {
			background-color: $tooltip-bg-color;
			border-radius: 0.625rem;
			bottom: -2.3125rem;
			color: $tooltip-text-color;
			font-size: 1rem;
			margin-right: -7.75rem;
			padding: 0.625rem 0 0.625rem 0.9375rem;
			position: relative;
			visibility: hidden;
			white-space: nowrap;
			z-index: 1;
			@media (max-width: $mobile) {
				bottom: -2.3625rem;
				font-size: .875rem;
				margin-left: -5.6rem;
				position: absolute;
			}
			&:after {
				border: 0.4375rem solid;
				border-color: transparent transparent $tooltip-bg-color
					transparent;
				content: "";
				position: relative;
				right: 6.6875rem;
				top: -2.350rem;
				@media (max-width: $mobile) {
					right: 5.8125rem;
					top: -2.150rem;
				}
			}
		}
	}
	.sponsor-attribution-text {
		color: $sponsor-text-color;
		font-size: 0.75rem;
		margin-right: 0.625rem;
		@media (max-width: $tablet) {
			font-size: 0.625rem;
			margin-right: 0.438rem;
		}
	}
	.sponsor-attribution-logo {
		img {
			height: 1.75rem;
			width: auto;
			@media (max-width: $mobile) {
				height: auto;
				max-height: 1.75rem;
				max-width: 6.25rem;
			}
		}
	}
}
</style>
